module.exports = __webpack_public_path__ + "static/media/check.cc994465.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/check.svg
// module id = 1250
// module chunks = 0